module.exports = __webpack_public_path__ + "img/no-materials.1f69eb26.svg";